/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class PartialSurveyQuestion {
    'id': number;
    'question': string;
    'choices'?: string;
    'order'?: number;
    'questionTranslationKey'?: string;
    'singleAnswer'?: boolean;
    'userOrder'?: boolean;
    'choicesTranslactionKey'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "question",
            "baseName": "question",
            "type": "string",
            "format": ""
        },
        {
            "name": "choices",
            "baseName": "choices",
            "type": "string",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "number",
            "format": ""
        },
        {
            "name": "questionTranslationKey",
            "baseName": "questionTranslationKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "singleAnswer",
            "baseName": "singleAnswer",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "userOrder",
            "baseName": "userOrder",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "choicesTranslactionKey",
            "baseName": "choicesTranslactionKey",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PartialSurveyQuestion.attributeTypeMap;
    }

    public constructor() {
    }
}

